<template>
  <div v-if="hidden">
    <div v-show="show">
      <slot />
    </div>
  </div>
  <div v-else>
    <slot v-if="show" />
  </div>
</template>

<script>
export default {
  name: "Display",
  props: {
    for: String,
    hidden: Boolean,
    when: [String, Number, Array, Function],
    whenNot: [String, Number, Array, Function]
  },
  data: () => ({
    show: false
  }),
  methods: {
    test(rule, val) {
      if (typeof rule === "function") {
        return rule(val);
      }

      if (Array.isArray(rule)) {
        return rule.includes(val);
      }

      return val == rule;
    },
    onChange(e) {
      const value = e.target.value;
      let when = true,
        whennot = false;

      if (this.when !== undefined) {
        when = this.test(this.when, value);
      }

      if (this.whenNot !== undefined) {
        whennot = this.test(this.whenNot, value);
      }

      this.show = when && !whennot;
    }
  },
  mounted() {
    const target = document.querySelector(`[name="${this.for}"]`);

    ["change", "input"].forEach(event => {
      target.addEventListener(event, e => this.onChange(e));
    });

    this.onChange({ target });
  }
};
</script>
